import { yodaStakeholderConstants } from "../constants";

const initialState = {
  loading: false,
  stakeholder: [],
  me: null,
  orderHistory: [],
  orderHistoryNewCount: 0,
};

const stakeholderReducer = (state = { ...initialState }, action) => {
  switch (action.type) {
    case yodaStakeholderConstants.GETALL_REQUEST:
      return {
        ...state,
        loading: true,
        stakeholder: [],
      };

    case yodaStakeholderConstants.GETALL_SUCCESS:
      return {
        ...state,
        stakeholder: action.payload.stakeholder,
        loading: false,
      };

    case yodaStakeholderConstants.GETALL_FAILURE:
      return {
        ...state,
        error: action.payload.error,
        loading: false,
      };

    case yodaStakeholderConstants.GETME_REQUEST:
      return {
        ...state,
        //loading: true,
      };

    case yodaStakeholderConstants.GETME_SUCCESS:
      return {
        ...state,
        me: action.payload.me,
        //loading: false
      };

    case yodaStakeholderConstants.GETME_FAILURE:
      return {
        ...state,
        error: action.payload.error,
        me: null,
        //loading: false
      };

    case yodaStakeholderConstants.GET_ORDER_HISTORY_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case yodaStakeholderConstants.GET_ORDER_HISTORY_SUCCESS:
      return {
        ...state,
        orderHistory: action.payload.orderHistory,
        loading: false,
      };

    case yodaStakeholderConstants.GET_ORDER_HISTORY_FAILURE:
      return {
        ...state,
        error: action.payload.error,
        orderHistory: [],
        loading: false,
      };

    case yodaStakeholderConstants.ORDER_HISTORY_RESET:
      return {
        ...state,
        orderHistory: [],
      };

    case yodaStakeholderConstants.GET_ORDER_HISTORY_NEW_COUNT_REQUEST:
      return {
        ...state,
      };

    case yodaStakeholderConstants.GET_ORDER_HISTORY_NEW_COUNT_SUCCESS:
      return {
        ...state,
        orderHistoryNewCount: action.payload.orderHistoryNewCount,
      };

    case yodaStakeholderConstants.GET_ORDER_HISTORY_NEW_COUNT_FAILURE:
      return {
        ...state,
        error: action.payload.error,
        orderHistoryNewCount: 0,
      };
    case yodaStakeholderConstants.RESET:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};

export default stakeholderReducer;
